import { Component, Input, OnInit } from '@angular/core';
import { A48ReportTypes } from 'src/app/enums/reports/a48-reports.enum';
import { TimeTrackingReportEntry } from 'src/app/model/time-tracking/time-tracking-report-entry.model';
import { CplTimeTrackingReportRequest } from 'src/app/model/cpl-time-tracking-report-reqest.model';
import { A48UserStatus } from 'src/app/model/enum/a48-user-status.enum';
import { ReportHelpersService } from 'src/app/services/report-helpers/report-helpers.service';
import { DateHelpers, PagedResponse } from '@edl-development/edl-common';
import { A48ReportPerms } from 'src/app/enums/reports/a48-report-perms.enum';
import { A48SubmissionContextCode } from 'src/app/model/enum/a48-submission-context-code.enum';
import { TimeTrackingTypes } from 'src/app/model/enum/cpl-time-tracking-type.enum';

@Component({
    templateUrl: './time-tracking-print-report.component.html',
    styleUrls: ['./time-tracking-print-report.component.scss']
})
export class TimeTrackingPrintReportComponent implements OnInit {
    @Input() pagedResponse: PagedResponse;
    @Input() request: CplTimeTrackingReportRequest;

    reportContent: TimeTrackingReportEntry[];

    DateHelpers = DateHelpers;
    A48ReportTypes = A48ReportTypes;
    A48UserStatus = A48UserStatus;
    A48SubmissionContextCode = A48SubmissionContextCode;

    constructor(
        public reportHelpersService: ReportHelpersService
    ) {}

    ngOnInit() {
        this.reportContent = this.pagedResponse.Results;
    }

    get isAct48Report() {
        return this.request.TimeTrackingType == TimeTrackingTypes.ACT48;
    }

    getPermsLabel() {
        switch (this.request.Perms) {
            case A48ReportPerms.NO_PERMS:
                return 'Not Submitted';
            case A48ReportPerms.PERMS:
                return 'Submitted';
            default:
                return 'All Completed Submissions';
        }
    }

    getTitle = () => {
        return this.reportHelpersService.getTitle(this.request.Type, this.request.TimeTrackingType);
    }
}